export const header = {
  menu: [
    {
      id: 1,
      url: '#about-card',
      text: 'About',
      icon: 'la-user',
    },
    // {
    //   id: 2,
    //   url: "#resume-card",
    //   text: "Resume",
    //   icon: "la-gear",
    // },
    {
      id: 2,
      url: '#works-card',
      text: 'Portfolio',
      icon: 'la-eye',
    },
    {
      id: 3,
      url: 'https://sharooq.com/',
      text: 'Blog',
      icon: 'la-newspaper-o',
    },
    {
      id: 4,
      url: '#contacts-card',
      text: 'Contact',
      icon: 'la-envelope',
    },
  ],
  social: [
    // {
    //   link: "https://dribbble.com/",
    //   icon: "la-dribbble",
    // },

    {
      link: 'https://github.com/SharooqSalaudeen',
      icon: 'la-github',
    },
    {
      link: 'https://www.linkedin.com/in/sharooq-salaudeen/',
      icon: 'la-linkedin',
    },
    // {
    //   link: 'https://www.instagram.com/sharooqsalaudeen/',
    //   icon: 'la-instagram',
    // },
  ],
};

export const resume = {
  work: [
    {
      title: 'Software Engineer - Centrica',
      year: 'June 2024 - Present',
      location: 'London, England, United Kingdom',
      description: `Architected and led development of “Cosmo 2.0”, a next-generation AI-powered customer self-service platform for web and voice channels, designed to reduce contact centre dependency and improve automated customer journey completion.
    Transitioned a legacy deterministic Amazon Lex conversational model into a probabilistic GenAI-driven orchestration framework using Amazon Bedrock and Claude models, significantly improving conversational flexibility and context retention.
    Designed and implemented orchestration layers integrating Amazon Connect, AWS Lambda, Bedrock, API Gateway, Redis, and DynamoDB session memory to support context-aware conversational workflows.
    Implemented AI intent-routing strategies using Claude Haiku for lightweight intent classification, Claude Sonnet for conversational workflows, and Claude Opus for complex multi-intent customer requests.
    Built intelligent fallback handling and retrieval-augmented response systems using Bedrock Knowledge Bases powered by customer FAQs, pricing plans, terms & conditions, and support documentation.
    Developed a modern Next.js conversational testing platform for Cosmo 2.0, accelerating internal experimentation, feature validation, and proof-of-concept delivery.
    Led rapid AI prototyping and proof-of-concept delivery across the engineering organisation, enabling architecture discussions, stakeholder alignment, and technical decision-making.
    Collaborated directly with engineering leadership and senior stakeholders, reporting technical progress, coordinating proof-of-concept iterations, and managing task allocation across contractors.
    Architected and deployed scalable Amazon Connect contact centre solutions including agent workspace, customer cases, and customer profiles, improving customer service responsiveness by 35% and reducing average wait times by 25%.
    Developed and maintained 100+ AWS Lambda functions and Amazon Lex bots supporting authentication, multi-intent recognition, and self-service automation, enabling over 40% of customer queries to be resolved without agent intervention.
    Accelerated logged-out customer verification time by 70% by implementing a postcode-based identity matching mechanism, streamlining authentication workflows.
    Implemented CI/CD pipelines and infrastructure-as-code workflows using GitHub Actions and Terraform, reducing release cycles by 50% and improving deployment consistency across environments.`,
      newTechnologies: [
        { name: 'AWS', image: 'aws' },
        { name: 'Terraform', image: 'terraform' },
        { name: 'Github', image: 'github' },
        { name: 'DynamoDB', image: 'dynamodb' },
        { name: 'NextJS', image: 'nextjs' },
        { name: 'Express', image: 'express' },
        { name: 'Connect', image: 'amazonconnect' },
      ],
      otherTechnologies: [
        'TypeScript',
        'NodeJS',
        'Git',
        'Github',
        'JavaScript',
        'HTML',
        'CSS',
      ],
    },
    {
      title: 'Software Engineer (Contract) - Hatless Studios',
      year: 'November 2023 - January 2024',
      location: 'Exeter, England, United Kingdom',
      description: `Delivered a production-ready full-stack application using Next.js and PostgreSQL for a legal services client, implementing secure REST APIs and strict document handling workflows to minimise data breach risks.
    Increased automated test coverage from 60% to 90% using Jest, reducing regression defects and improving release stability across subsequent deployments.
    Designed and implemented CI pipelines with GitHub Actions, reducing manual deployment effort by 60% and cutting release cycles from 3 weeks to 1.5 weeks.
    Collaborated within Agile teams across sprint planning, technical discussions, and iterative product delivery.`,
      newTechnologies: [
        { name: 'Docker', image: 'docker' },
        { name: 'ReactJS', image: 'reactjs' },
        { name: 'PostgreSQL', image: 'postgresql' },
        { name: 'MySQL', image: 'mysql' },
        { name: 'Redux', image: 'redux' },
        { name: 'Express', image: 'express' },
      ],
      otherTechnologies: [
        'TypeScript',
        'Redux-Toolkit',
        'ReactJS',
        'NodeJS',
        'Git',
        'Github',
        'JavaScript',
        'HTML',
        'CSS',
      ],
    },
    {
      title: 'Software Engineer - Ampcome',
      year: 'August 2021 - August 2022',
      location: 'Bangalore, KA, India',
      description: `Delivered 3 production-ready full-stack platforms including e-commerce, learning management, and online coaching systems using React, Node.js, and AWS cloud infrastructure.
    Built and optimised Stripe payment workflows supporting thousands of daily transactions with 99.9% reliability across multiple production systems.
    Reduced database query load by 35% and infrastructure costs by 20% by implementing Redis caching strategies across high-traffic application workflows.
    Designed GraphQL APIs using Hasura GraphQL Engine, reducing frontend data over-fetching by 60% and improving response times by 30%.
    Led implementation of a fully serverless cloud architecture using AWS Lambda, Fargate, API Gateway, and DynamoDB, reducing infrastructure management overhead and enabling seamless scalability.`,
      newTechnologies: [
        { name: 'AWS', image: 'aws' },
        { name: 'Redux', image: 'redux' },
        { name: 'Express', image: 'express' },
        { name: 'Amplify', image: 'amplify' },
        { name: 'GraphQL', image: 'graphql' },
        { name: 'Cloudinary', image: 'cloudinary' },
        { name: 'Gitlab', image: 'gitlab' },
        { name: 'PostgreSQL', image: 'postgresql' },
        { name: 'AntDesign', image: 'antdesign' },
        { name: 'Hasura', image: 'hasura' },
        { name: 'MaterialUI', image: 'materialui' },
        { name: 'Prismic', image: 'prismic' },
        { name: 'DynamoDB', image: 'dynamodb' },
      ],
      otherTechnologies: [
        'Stripe',
        'Fawry',
        'Redux-Toolkit',
        'Sass',
        'LESS',
        'ReactJS',
        'NodeJS',
        'Git',
        'Netlify',
        'Github',
        'JavaScript',
        'HTML',
        'CSS',
      ],
    },
    // {
    //   title: 'Software Engineer - Asama',
    //   year: '2020-2021',
    //   // location: "Trivandrum",
    //   description: `Led the migration of WordPress application to React and Express server while maintaining the existing MySQL database, resulting in a 60% enhancement in web application performance and a more modernised user experience.
    //   Implemented CI/CD pipeline utilising GitHub Actions, which improved the deployment efficiency by 70% and minimised update downtime, ensuring seamless and rapid delivery of new features.
    //   Introduced Python automation solutions for document management, leveraging custom scripts and libraries to streamline processes, and thereby fostering increased productivity.
    //   Ensured the compatibility of SSL protocol for websites and maintained various internal system servers through proactive monitoring, configuration adjustments, and timely updates, safeguarding data integrity and enhancing system security.`,
    //   newTechnologies: [
    //     { name: 'ReactJS', image: 'reactjs' },
    //     { name: 'GCP', image: 'gcp' },
    //     { name: 'Firebase', image: 'firebase' },
    //     { name: 'Github', image: 'github' },
    //     { name: 'MySQL', image: 'mysql' },
    //     { name: 'Apache', image: 'apache' },
    //     { name: 'Netlify', image: 'netlify' },
    //     { name: 'cPanel', image: 'cpanel' },
    //     { name: 'Bootstrap', image: 'bootstrap' },
    //   ],
    //   otherTechnologies: [
    //     'ReactJS',
    //     'NodeJS',
    //     'Styled Components',
    //     'Git',
    //     'Wordpress',
    //     'JavaScript',
    //     'HTML',
    //     'CSS',
    //   ],
    // },
    {
      title: 'Software Engineer (Freelance)',
      year: 'February 2020 - August 2021',
      location: 'Thiruvananthapuram, KL, India',
      description: `Delivered and maintained 11 custom web applications using MERN stack technologies and WordPress-based solutions for clients across multiple industries.
    Managed end-to-end project delivery including client communication, hosting, deployment, and ongoing technical support.
    Maintained strong client relationships, with 25% of clients returning for additional projects.`,
      newTechnologies: [
        { name: 'NodeJS', image: 'nodejs' },
        { name: 'Git', image: 'git' },
        { name: 'Wordpress', image: 'wordpress' },
        { name: 'ReactJS', image: 'reactjs' },
        { name: 'GCP', image: 'gcp' },
        { name: 'Firebase', image: 'firebase' },
        { name: 'Github', image: 'github' },
        { name: 'MySQL', image: 'mysql' },
        { name: 'Apache', image: 'apache' },
        { name: 'Netlify', image: 'netlify' },
        { name: 'cPanel', image: 'cpanel' },
        { name: 'Bootstrap', image: 'bootstrap' },
        { name: 'CSS3', image: 'css3' },
        { name: 'JavaScript', image: 'javascript' },
        { name: 'HTML5', image: 'html5' },
      ],
    },
  ],
  education: [
    {
      title: 'MSc Applied Data Science and Statistics - University of Exeter',
      year: '2022-2023',
      // place: "Trivandrum",
      description: `Demonstrated academic excellence by achieving distinction in the academic program, showcasing leadership skills as President of the Data Science Society, and earning prestigious accolades including the Exeter Award and Exeter Leaders Award.`,
    },
    {
      title: 'B.Tech Computer Science - Kerala Technological University',
      year: '2015-2019',
      // place: "Trivandrum",
    },
    // {
    //   title: 'High School - Kendriya Vidhyalaya',
    //   year: '2013-2015',
    //   // place: "Trivandrum",
    // },
  ],
  certifications: [
    {
      title:
        'AWS Cloud Solutions Architect Specialisation - Amazon Web Services',
      year: '2024',
      // place: "Trivandrum",
      description: [
        '•  AWS Cloud Technical Essentials',
        '•  Architecting Solutions on AWS',
        '•  Designing Data Lakes on AWS',
      ],
    },
    {
      title: 'TensorFlow Developer Specialization - DeepLearning.AI',
      year: '2023',
      // place: "Trivandrum",
      description: [
        '•  Natural Language Processing',
        '•  Time series prediction',
        '•  Convolutional Neural Networks',
        '•  Deep Learning',
        '•  Artificial Intelligence',
      ],
    },
    {
      title:
        'Machine Learning Specialization - Stanford University, DeepLearning.AI',
      year: '2022',
      // place: "Trivandrum",
      description: [
        '•  Modern machine learning methodologies',
        '•  Supervised and unsupervised learning',
        '•  Recommender systems',
        '•  Reinforcement learning',
      ],
    },
    {
      title: 'MongoDB Node.js Developer - MongoDB',
      year: '2024',
      // place: "Trivandrum",
      description: [
        '•  Efficient database integration, performance, and scalability',
      ],
    },
  ],
  personalskills: [
    {
      name: 'javascript',
      percentage: '90%',
    },
    {
      name: 'React JS',
      percentage: '80%',
    },
    {
      name: 'NodeJS',
      percentage: '70%',
    },
    {
      name: 'Redux',
      percentage: '75%',
    },
  ],
  professionalskills: [
    {
      name: 'Python',
      percentage: '80%',
    },
    {
      name: 'C#',
      percentage: '85%',
    },
    {
      name: 'HTML / CSS',
      percentage: '95%',
    },
    {
      name: 'Wordpress',
      percentage: '85%',
    },
  ],

  otherSkills: [
    { name: 'Expo', image: 'expo' },
    { name: 'React Native', image: 'reactjs' },
    { name: 'Apollo', image: 'apollo' },
    { name: 'MongoDB', image: 'mongodb' },
    { name: 'Vercel', image: 'vercel' },
    { name: 'Heroku', image: 'heroku' },
    { name: 'Python', image: 'python' },
    { name: 'C#', image: 'csharp' },
    { name: 'Unity', image: 'unity' },
    { name: 'Photoshop', image: 'photoshop' },
  ],
};

export const contact = [
  // {
  //   title: "Address",
  //   icon: "la-map-marker",
  //   content: "Trivandrum, Kerala.",
  //   link: "",
  // },
  {
    title: 'Email',
    icon: 'la-at',
    content: 'iamsharooq@gmail.com',
    link: 'mailto:iamsharooq@gmail.com',
  },
  {
    title: 'LinkedIn',
    icon: 'la-linkedin',
    content: 'Sharooq Salaudeen',
    link: 'https://www.linkedin.com/in/sharooq-salaudeen/',
    target: '_blank',
  },
  // {
  //   title: 'Phone',
  //   icon: 'la-phone',
  //   content: '+44 07443784138',
  //   link: 'tel:+44 07443784138',
  // },
  // {
  //   title: "Freelance",
  //   icon: "la-check-square",
  //   content: "Available",
  //   link: "#ContactForm",
  // },
];

// export const portfolio = {
//   filter: [
//     { label: 'All', value: 'grid-item' },
//     { label: 'Photo', value: 'photo' },
//     { label: 'Video', value: 'video' },
//     { label: 'Music', value: 'music' },
//     { label: 'Design', value: 'design' },
//   ],
//   works: [
//     {
//       type: 'photo',
//       design: 'image',
//       link: 'images/works/work1.jpg',
//       image: 'images/works/work1.jpg',
//       title: 'Motorcycle Helmet',
//     },
//     {
//       type: 'video',
//       design: 'video',
//       link: 'https://vimeo.com/97102654',
//       image: 'images/works/work2.jpg',
//       title: 'Minimalism Shapes',
//     },
//     {
//       type: 'music',
//       design: 'music',
//       link: 'https://w.soundcloud.com/player/?visual=true&url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F221650664&show_artwork=true',
//       image: 'images/works/work3.jpg',
//       title: 'Staircase',
//     },
//     {
//       type: 'design',
//       design: 'media',
//       link: 'popup-1',
//       image: 'images/works/work4.jpg',
//       title: 'Mobile Application',
//       content: [
//         '<p>So striking at of to welcomed resolved. Northward by described up household therefore attention. Excellence decisively nay man yet impression for contrasted remarkably.</p>',
//         '<p>Morbi viverra tincidunt nisl, eget placerat erat. Morbi ornare mollis quam, sit amet vestibulum e:</p>',
//         "<ul class='list-style'><li>Greatest properly off ham exercise all.</li><li>Unsatiable invitation its possession nor off.</li><li> All difficulty estimating unreserved increasing the solicitude. </li></ul>",
//       ],
//       projectlink: '/#',
//     },
//     {
//       type: 'photo',
//       design: 'image',
//       link: 'images/works/work5.jpg',
//       image: 'images/works/work5.jpg',
//       title: 'Gereal Travels',
//     },
//     {
//       type: 'music',
//       design: 'music',
//       link: 'https://w.soundcloud.com/player/?visual=true&url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F221650664&show_artwork=true',
//       image: 'images/works/work8.jpg',
//       title: 'Daylight Entrance',
//     },
//     {
//       type: 'video',
//       design: 'video',
//       link: 'https://vimeo.com/97102654',
//       image: 'images/works/work6.jpg',
//       title: 'Architecture',
//     },
//     {
//       type: 'design',
//       design: 'media',
//       link: 'popup-2',
//       image: 'images/works/work7.jpg',
//       title: 'Social Website',
//       content: [
//         '<p>So striking at of to welcomed resolved. Northward by described up household therefore attention. Excellence decisively nay man yet impression for contrasted remarkably.</p>',
//         '<p>Morbi viverra tincidunt nisl, eget placerat erat. Morbi ornare mollis quam, sit amet vestibulum e:</p>',
//         "<ul class='list-style'><li>Greatest properly off ham exercise all.</li><li>Unsatiable invitation its possession nor off.</li><li> All difficulty estimating unreserved increasing the solicitude. </li></ul>",
//       ],
//       projectlink: '/#',
//     },
//   ],
// };

export const myportfolio = {
  filter: [
    { label: 'All', value: 'grid-item' },
    // { label: "Photo", value: "photo" },
    { label: 'NextJS', value: 'nextjs' },
    { label: 'ReactJS/NodeJS', value: 'reactjs-nodejs' },
    { label: 'Wordpress', value: 'wordpress' },
  ],
  works: [
    {
      type: 'reactjs-nodejs',
      projecttype: 'personal project',
      design: 'media',
      link: 'popup-14',
      thumbnailimage: 'images/myworks/read-insight/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/read-insight/portfolio.jpg',
      title: 'Read Insight',
      content: [
        '<p>Developed an A.I.-powered news website using fine-tuned LLM models, Docker, Node.js, and PostgreSQL to automate real-time news aggregation, article generation, and publication on a streamlined frontend.</p>',
      ],
    },
    {
      type: 'nextjs',
      projecttype: 'personal project',
      design: 'media',
      link: 'popup-13',
      thumbnailimage: 'images/myworks/sharooq/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/sharooq/portfolio.jpg',
      title: 'Sharooq.com',
      content: [
        '<p>Developed a serverless website using the Next.js framework, attaining a perfect Google Lighthouse score of 100 and successfully attracted a peak monthly user base of 40,000.</p>',
      ],
      projectlink: 'https://sharooq.com',
    },
    {
      type: 'wordpress',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-12',
      thumbnailimage: 'images/myworks/masjidul-malik/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/masjidul-malik/portfolio.jpg',
      title: 'Masjidul Malik',
      content: [
        '<p>This app is built on Wordpress and the Elementor framework, with security and functionality in mind. Application is hosted on a linux/Apache server with mySQL database.</p>',
      ],
    },
    {
      type: 'reactjs-nodejs',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-11',
      thumbnailimage: 'images/myworks/asamaco/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/asamaco/portfolio.jpg',
      title: 'Asamaco Construction',
      content: [
        '<p>This ReactJS application is hosted on a Linux server because the client required a custom email server. Consequently, both the email functionality and website are managed on a single server. Originally developed using WordPress and Elementor framework, the application was later migrated to ReactJS. </p>',
      ],
      projectlink: 'http://asamaco.com/',
    },
    {
      type: 'wordpress',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-10',
      thumbnailimage: 'images/myworks/alif-dental-care/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/alif-dental-care/portfolio.jpg',
      title: 'Alif Dental Care',
      content: [
        '<p>Built with a focus on security and functionality, the project includes an integrated online consultation booking feature. The application, developed using WordPress and the Elementor framework, is hosted on a Linux/Apache server with a MySQL database backend.</p>',
      ],
    },
    {
      type: 'wordpress',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-9',
      thumbnailimage: 'images/myworks/helmet-zone/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/helmet-zone/portfolio.jpg',
      title: 'Helmet Zone',
      content: [
        "<p>A marketplace specializing in helmets, offering a diverse range of brands spanning from budget-friendly options to premium selections. I actively participated in numerous meetings with potential vendors, contributed to inventory management, logistics, and advertising strategies. This project allowed me to play a hands-on role in every aspect of operations until the onset of the COVID-19 pandemic, which unfortunately resulted in the business's decline.</p>",
      ],
    },
    {
      type: 'wordpress',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-8',
      thumbnailimage: 'images/myworks/naadan-chantha/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/naadan-chantha/portfolio.jpg',
      title: 'Naadan Chantha',
      content: [
        '<p>A marketplace dedicated to naturally grown vegetables and fruits sourced directly from farms participating in a government-authorized scheme. This serves as an online ecommerce platform designed to amplify the visibility of these farms and facilitate trading.</p>',
      ],
    },
    // {
    //   type: 'design',
    //   projecttype: 'personal project',
    //   design: 'media',
    //   link: 'popup-7',
    //   thumbnailimage: 'images/myworks/business-card/thumbnail-resized.jpg',
    //   portfolioimage: 'images/myworks/business-card/portfolio.jpg',
    //   title: 'Personal business Card',
    //   content: [
    //     '<p>This project is an extension to my knowledge base on Graphic designing and Photoshop  </p>',
    //   ],
    // },
    {
      type: 'wordpress',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-6',
      thumbnailimage: 'images/myworks/al-taj-hotels/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/al-taj-hotels/portfolio.jpg',
      title: 'Al Taj Hotels',
      content: [
        '<p>The application includes an online hotel booking feature, with backend access for reservation management. Built on the WordPress and Elementor framework, the application is hosted on a Linux/Apache server with a MySQL database.</p>',
      ],
    },

    {
      type: 'reactjs-nodejs',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-5',
      thumbnailimage: 'images/myworks/betterpeeps/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/betterpeeps/portfolio.jpg',
      title: 'Betterpeeps',
      content: [
        '<p>BetterPeeps is a blog platform developed using the MERN stack (MongoDB, Express.js, React, Node.js). The frontend is built with React, while Strapi was used as a content management system to create, manage, and organize blog posts efficiently. The project features a dynamic user interface with backend data management and basic user interaction features.</p>',
      ],
    },
    {
      type: 'wordpress',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-4',
      thumbnailimage: 'images/myworks/juoc/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/juoc/portfolio.jpg',
      title: 'JUOC Fashion Store',
      content: [
        '<p>This project entails an online shopping website built using WordPress and WooCommerce. It is hosted on a Linux/Apache server with a MySQL database.</p>',
      ],
    },
    {
      type: 'reactjs-nodejs',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-3',
      thumbnailimage: 'images/myworks/ktu-official/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/ktu-official/portfolio.jpg',
      title: 'KTUOfficial Student portal',
      content: [
        '<p>An online platform was created for students at my university to access and download free notes and presentations. The frontend was built with React, while Strapi was used as a content management system to populate and organize materials efficiently. Despite attracting significant traffic, it was eventually shut down as it began to impact the time I spent on my academic work. The most challenging aspect of this project was aggregating study materials from diverse engineering streams through multiple sources, both on and off campus. I managed the application for over two years before transferring the collected materials to other well-maintained platforms with consent.</p>',
      ],
    },

    {
      type: 'wordpress',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-2',
      thumbnailimage: 'images/myworks/wolf-county/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/wolf-county/portfolio.jpg',
      title: 'Wolfcounty',
      content: [
        '<p>A website has been developed using WordPress to connect with potential customers, aiming to facilitate conversion to Facebook Marketplace, where products are listed.</p>',
      ],
    },
    {
      type: 'reactjs-nodejs',
      projecttype: 'client project',
      design: 'media',
      link: 'popup-1',
      thumbnailimage: 'images/myworks/mehr-sha/thumbnail-resized.jpg',
      portfolioimage: 'images/myworks/mehr-sha/portfolio.jpg',
      title: 'Mehr Sha Realty',
      content: [
        '<p>This is a landing page for the Mehr Sha realty company, built with a React frontend. The backend uses a Node.js server to handle contact form submissions and stores the data securely in MongoDB.</p>',
      ],
    },
  ],
};
